<script setup lang="ts">
const special_offer = [
    './images/restaurant/intro-img-1.jpg',
    './images/restaurant/intro-img-2.jpg',
    './images/restaurant/intro-img-3.jpg',
    './images/restaurant/intro-img-4.jpg',
]
import {defineProps} from "vue";
const props = defineProps({
  appointment: {},
  restaurantHero:{},
  presentation:{}
});
</script>

<template>
  <div class="impx-slide-container style1 resto">
    <div class="impx-slideshow-fw">
      <div class="impx-hero-resto uk-position-relative  uk-background-fixed uk-background-center-center uk-height-1-1">
        <div class="impx-overlay dark"></div>
        <div class="uk-container">
          <div class="uk-grid uk-flex uk-flex-center uk-flex-middle">
            <div class="uk-width-1-2@xl uk-width-1-2@l uk-width-1-1@m  uk-width-1-1@s uk-position-center uk-margin-large-top">
              <div class="impx-slide-fw-caption resto-caption uk-position-relative uk-position-z-index uk-text-center uk-light">
                <!-- intro -->
                <h1 class="impx-text-shadow">{{props.restaurantHero?.title??''}}</h1>
                <p class="uk-margin-remove impx-text-shadow uk-text-lead">{{props.restaurantHero?.subtitle}}</p>
                <div class="uk-margin">
                  <i class="fa fa-coffee  impx-slide-icon impx-text-white"></i>
                  <i class="fa fa-cutlery  impx-slide-icon impx-text-white"></i>
                  <i class="fa fa-glass   impx-slide-icon impx-text-white"></i>
                </div>
                <!-- intro end -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- HERO IMAGE END -->

  <!-- FEATURES -->
  <div class="uk-padding uk-padding-remove-horizontal uk-padding-remove-bottom bg-color-gray  pattern-1 impx-resto-badge">
    <div class="uk-container">
      <div class="uk-grid">
        <!-- Image -->
        <div class="uk-width-2-5@xl uk-width-2-5@l uk-width-2-5@m uk-width-1-1@s uk-vertical-align-bottom uk-position-relative uk-position-z-index impx-negative-top xxlarge">
          <img :src="appointment?.presentation[0]?.heroImage?.url" alt="Restaurant" class="img-resto-intro uk-align-center"/>
        </div>
        <!-- Image End -->
        <!-- Contact Info -->
        <div class="uk-width-3-5@xl uk-width-3-5@l uk-width-3-5@m uk-width-1-1@s impx-intro resto">
          <h3>{{appointment?.presentation[0]?.title??''}}</h3>
          <p class="impx-text-large uk-margin-bottom">{{appointment?.presentation[0]?.content??''}}</p>
          <ul class="impx-list-inline impx-hours">
            <li v-for="(menuHour,index) in appointment?.AppointmentMenu" :key="index">
              <i class=" {{menuHour?.icon}} impx-text-csa"></i><strong class="impx-text-csa">{{ menuHour?.title}}</strong> {{menuHour?.hour}}</li>
          </ul>
        </div>
        <!-- Contact Info End -->
      </div>
    </div>
  </div>
  <!-- FEATURES END -->
  <!-- HIGHLIGHT -->
  <div class="uk-padding uk-margin-bottom resto-feat uk-padding-remove-horizontal">
    <div class="uk-container">
      <div data-uk-grid>

        <div class="uk-width-2-3@xl uk-width-2-3@l uk-width-1-1@m uk-width-1-1@s uk-margin-top">
          <div class="impx-intro resto margin-medium"><!-- intro -->
            <h3>{{presentation?.title??''}}</h3>
            <p class="uk-margin-medium-bottom impx-text-large">{{presentation?.subtitle??''}}</p>
          </div><!-- intro end -->

          <!-- highlight items -->
          <ul class="uk-child-width-1-2@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-2@s" data-uk-grid>
            <li class="resto-feat-item"
                v-for="(appointKeyPoint,index) in presentation?.presentationItems" :key="index"
            ><!-- highlight item #1 -->
              <div data-uk-grid>
                <div class="uk-width-1-3@xl uk-width-1-3@l uk-width-1-3@m uk-width-1-1@s">
                  <div class="uk-position-relative">
                    <img :src="special_offer[0]" alt="resort" class="uk-border-circle">
                    <div class="impx-overlay light overlay-outline padding-medium"></div>
                  </div>
                </div>
                <div class="uk-width-2-3@xl uk-width-2-3@l uk-width-2-3@m uk-width-1-1@s">
                  <h5 class="uk-margin-remove-bottom">{{appointKeyPoint?.title}}</h5>
                  <p class="uk-margin-small-top uk-margin-remove-bottom">{{appointKeyPoint?.content}}</p>
                </div>
              </div>
            </li><!-- highlight item #1 end -->
          </ul>
          <!-- highlight items end -->
        </div>

        <!-- Intro Text -->
        <div class="uk-width-1-3@xl uk-width-1-3@l uk-width-1-1@m">
          <div class="impx-img-stacked uk-padding-remove-horizontal">
            <img :src="'../images/gallery/price-bg.png'" alt="cité sainte augustine resto" class="">
            <img :src="'../images/heading/room-3.jpg'" alt="csa restaurant" class="">
          </div>
        </div>
        <!-- Intro Text End -->

      </div>
    </div>
  </div>
  <!-- HIGHLIGHT -->
</template>

<style scoped>

</style>